/// <reference path='../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../typings/tsd.d.ts' />
class SWActionViewController{

	public action; 
	public permissions;
	public displayOnNoAccess;
	
	public hasPermission: boolean = false;

    
    //@ngInject
    constructor(
    ){
    }
    
    public $onInit = ()=>{
        if(this.displayOnNoAccess == null){
            this.displayOnNoAccess = false;   
        } 
    }
    
	public evaluateActionForPermissions = (action=this.action, permissions=this.permissions) =>{
    	var hasPermission = false; 
    	
    	if(!permissions) return hasPermission;
    	
    	if(permissions['superUserFlag'] === true){
    		return true;
    	}
    	
    	var actionParts = action.split(':');
    	
    	var subsystem = actionParts[0];
    	
    	if(permissions[subsystem] == null){
    		return hasPermission;
    	}
    	
    	if(permissions[subsystem]['accessType'] != null && permissions[subsystem]['accessType'] === '*'){
    		return true;
    	} 
    	
    	var sectionParts = actionParts[1].split('.')
    	
    	var section = sectionParts[0];
    	
    	if(permissions[subsystem][section] == null){
    		return hasPermission	
    	}
    	
    	if(permissions[subsystem][section]['accessType'] != null && permissions[subsystem][section]['accessType'] === '*' ){
    		return true; 
    	}
    	
    	var item = sectionParts[1];
    	
    	if(permissions[subsystem][section][item] == null){
    		return hasPermission; 
    	}
    	
    	hasPermission = permissions[subsystem][section][item]['allowActionFlag']
    	
    	return hasPermission;
    }
}

class SWActionView implements ng.IDirective{
    public restrict = 'A';
    public bindToController = {
    	action: '@',
        permissions: '<',
        displayOnNoAccess: '=?'
    };
    public scope = true;
    public transclude = true;

    public controller=SWActionViewController;
    public controllerAs='swActionView';
    
    public static Factory(){
        var directive:ng.IDirectiveFactory = () => new SWActionView();
        directive.$inject = [];
        return directive;
    }
    //@ngInject
    constructor(
    ){}
    
	public link = (scope, iElement, iAttrs, controller, transcludeFn) =>{
	    
		
		 //because of the transcluded scope we will not be able to watch for changes to permissions therefore ng-if must be used on the parent directive
    	var hasPermission = controller.evaluateActionForPermissions();
    	
    	if( (  hasPermission && !controller.displayOnNoAccess ) ||
    	    ( !hasPermission &&  controller.displayOnNoAccess )    
    	){
            transcludeFn(scope, (clone) => {
                iElement.append(clone);
            });
    	} else {
    	    iElement.addClass('ng-hide');
    	}
	}

}
    
export{
    SWActionView
}
